import { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from "primereact/inputswitch";
import Logo from '../../../assets/york.png'
import Logo_LOGISTICA from '../../../assets/york_logistica.png'
import Coca from '../../../assets/coca.png'
import Eise from '../../../assets/eise.svg'
import InputMask from 'react-input-mask';
import html2canvas from 'html2canvas';
import './assinatura.css'
import InputForm from '../../../components/input/input';
import BranchService from '../../../services/resource/branchService';
import DropDown from '../../../components/dropdown/dropdown';
import { useAuth } from '../../../context/authContext';
import EmployeeService from '../../../services/resource/employeeService';

const initalValues = {
    name: '',
    fone: '(86) 3236-4215',
    license: 6425,
    office: '',
    email: '',
    branch: 'Rua Waldemar Rocha, 2804 - Parque Ideal',
    state: 'Teresina, PI',
    layout: "1",
    address: "1",
    phone: "",
    branchId: 1
}

const initialLicense = {
    name: 'Teresina',
    code: 6425,
    address: 'Rua Waldemar Rocha, 2804',
    state: 'Piauí',
    city: 'Teresina',
    neighborhood: 'Parque Ideal'
}

function Assinatura() {
    const { user, authenticated } = useAuth();
    const [values, setValues] = useState(initalValues);
    const [icon, setIcon] = useState(true);
    const [autorizado, setAutorizado] = useState(true);
    const [isCel, setIsCel] = useState(false);
    const [isCel2, setIsCel2] = useState(true);
    const [branch, setBranch] = useState([]);
    const [license, setLicense] = useState(initialLicense);
    const branchService = new BranchService();
    const employeeService = new EmployeeService();

    useEffect(() => {
         branchService.findAll().then(response => {
              setBranch(response.data);
          })
  
          if (authenticated) {
              employeeService.findById(user.userid).then(response => {
                  setValues(prev => ({
                      ...prev,
                      name: response.data.name,
                      email: response.data.email,
                      office: response.data.office,
                      phone: response.data.contact ? response.data.contact : '',
                  }))
              })
          } 
    }, []);

    useEffect(() => {
        if (values.license !== license.code) {
            const data = branch.find(x => x.code === Number(values.license));
            setLicense(data);
        }

    }, [values.license]);

    const onChange = (e) => {
        const { name, value } = e.target;

        setValues({
            ...values,
            [name]: value,
        });

    };

    function gerarImagem() {
        document.querySelector('#assinatura').classList.add("assinatura-download");
        html2canvas(document.getElementById('assinatura')).then(function (canvas) {
            var name = 'Assinatura ' + values.name;
            let xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function () {
                let a = document.createElement('a');
                a.href = window.URL.createObjectURL(xhr.response);
                a.download = name + '.png';
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                a.remove()
            };
            xhr.open('GET', canvas.toDataURL("image/png", 1.0));
            xhr.send();
        });
        document.querySelector('#assinatura').classList.remove("assinatura-download");
    }

    return (
        <div className="grid px-5">
            <SignatureForm
                values={values}
                onChange={onChange}
                isCel={isCel}
                isCel2={isCel2}
                setIsCel={setIsCel}
                setIsCel2={setIsCel2}
                branch={branch}
                autorizado={autorizado}
                setAutorizado={setAutorizado}
                gerarImagem={gerarImagem}
            />
            <SignaturePreview
                values={values}
                autorizado={autorizado}
                icon={icon}
                license={license}
                Logo={Logo}
                Coca={Coca}
                Eise={Eise}
            />
        </div>
    );

}


function SignatureForm({ values, onChange, isCel, setIsCel, branch, autorizado, setAutorizado, gerarImagem, isCel2, setIsCel2 }) {
    return (
        <div className="w-full mb-6">
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <div>
                    <InputForm type="text" label="Nome" name="name" maxLength={256} value={values.name} onChange={onChange} />
                </div>
                <div>
                    <InputForm type="text" label="Cargo" name="office" maxLength={256} value={values.office} onChange={onChange} />
                </div>
                <div className="sm:col-span-2">
                    <InputForm type="text" label="E-mail" name="email" maxLength={256} value={values.email} onChange={onChange} />
                </div>
                <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">Tipo de Contato 1</label>
                    <select
                        name="cel"
                        className="w-full border-1 border-gray-300 rounded-lg px-3 py-2"
                        value={isCel}
                        onChange={(e) => setIsCel(e.target.value === 'true')}
                    >
                        <option value="true">Celular</option>
                        <option value="false">Fixo</option>
                    </select>
                </div>

                <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">Número 1</label>
                    <InputMask
                        mask={isCel ? "(99) 99999-9999" : "(99) 9999-9999"}
                        className="w-full border-1 border-gray-300 rounded-lg px-3 py-2"
                        type="tel"
                        name="fone"
                        value={values.fone}
                        onChange={onChange}
                    />
                </div>
                <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">Tipo de Contato 2</label>
                    <select
                        name="cel2"
                        className="w-full border-1 border-gray-300 rounded-lg px-3 py-2"
                        value={isCel2}
                        onChange={(e) => setIsCel2(e.target.value === 'true')}
                    >
                        <option value="true">Celular</option>
                        <option value="false">Fixo</option>
                    </select>
                </div>
                <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">Número 2</label>
                    <InputMask
                        mask={isCel2 ? "(99) 99999-9999" : "(99) 9999-9999"}
                        className="w-full border-1 border-gray-300 rounded-lg px-3 py-2"
                        type="tel"
                        name="phone"
                        value={values.phone}
                        onChange={onChange}
                    />
                </div>
                <div className="sm:col-span-2 md:col-span-1">
                    <DropDown
                        id="DropBranchId"
                        name="license"
                        label="Filial"
                        label1="name"
                        optionValue="code"
                        optionLabel="name"
                        value={values.license}
                        options={branch}
                        onChange={onChange}
                    />
                </div>

                <div className="flex items-center space-x-3 mt-2 md:col-span-1">
                    <InputSwitch checked={autorizado} onChange={(e) => setAutorizado(e.value)} />
                    <label className="text-sm text-gray-700">Distribuidor autorizado</label>
                </div>
            </div>

            <div className="flex justify-center mt-6">
                <button
                    type="button"
                    onClick={gerarImagem}
                    className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700"
                >
                    Baixar assinatura
                </button>
            </div>
        </div>
    );
}

function SignaturePreview({ values, autorizado, icon, license, Logo, Coca, Eise }) {
    return (
        <div className='flex justify-center assinatura px-1' name="assinatura">
            {autorizado ?
                <div id='assinatura' className=''>
                    <table>
                        <tbody>
                            <tr className='container bg-york'>
                                <td style={{ height: '100% !important' }} className='h-100 d-flex align-items-bottom  align-bottom  da pb-2'>
                                    <div className='text-center' >
                                        <img className='logo' src={Logo} style={{ marginRight: '3px', marginBottom: '10px' }} width={232} height={65} alt='Logo-York' />

                                        <label style={{ fontWeight: '700', color: '#848484', fontFamily: 'calibri', marginBottom: '33px' }}>
                                            {autorizado ? "Distribuidor Autorizado" : "Distribuidor Logístico"}
                                        </label>
                                        <div className='flex justify-center'>
                                            <img src={Coca} width={78} alt='Coca-Cola' />
                                            <img src={Eise} width={72} height={18} alt='Eise Logo' />
                                        </div>
                                    </div>
                                </td>


                                <td className='h-100 px-2 py-2' style={{ fontFamily: 'arial, verdana', fontSize: "14.5px", height: '180px', verticalAlign: 'bottom' }}>
                                    <div className='grid gap-1'>
                                        <div className='text-center'>
                                            <strong>{values.name}</strong><br />
                                            <i>{values.office}</i><br />
                                        </div>
                                        <div>
                                            <strong>{icon ? <i className='bi bi-telephone-fill' /> : 'Telefone: '}</strong>
                                            <label> {values.fone} {values.phone && values.fone && " | "} {values.phone ? `${values.phone}` : ''}</label>
                                        </div>
                                        <div>
                                            <strong>{icon ? <i className='bi bi-envelope-at-fill' /> : 'E-mail: '}</strong>
                                            <label>{values.email}</label>
                                        </div>

                                        <div>
                                            <strong>{icon ? <i className='bi bi-globe' /> : 'Site: '}</strong>
                                            <label>www.distribuidorayork.com.br</label>
                                        </div>

                                        <div>
                                            <strong>{icon ? <i className='bi bi-geo-alt-fill' /> : 'Endereço: '}</strong>
                                            <label>{license.address} - {license.neighborhood}</label>
                                            <div className='mb-1'>
                                                <label style={icon ? { marginLeft: '23px' } : { marginLeft: '80px' }}>
                                                    {license.city}, {license.state}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                :
                <div id='assinatura' className=''>
                    <table>
                        <tbody>
                            <tr className='container bg-york'>
                                <td style={{ height: '100% !important' }} className='h-100 d-flex align-items-center  align-center  da pb-2'>
                                    <div className='text-center' >
                                        <img className='logo' src={Logo_LOGISTICA} style={{ marginRight: '3px', marginTop: '8px' }} width={250} alt='Logo-York' />
        
                                    </div>
                                </td>


                                <td className='h-100 px-2 py-2' style={{ fontFamily: 'arial, verdana', fontSize: "13.5px", height: '180px', verticalAlign: 'bottom' }}>
                                    <div className='grid gap-1'>
                                        <div className='text-center'>
                                            <strong>{values.name}</strong><br />
                                            <i>{values.office}</i><br />
                                        </div>
                                        <div>
                                            <strong>{icon ? <i className='bi bi-telephone-fill' /> : 'Telefone: '}</strong>
                                            <label> {values.fone} {values.phone && values.fone && " | "} {values.phone ? `${values.phone}` : ''}</label>
                                        </div>
                                        <div>
                                            <strong>{icon ? <i className='bi bi-envelope-at-fill' /> : 'E-mail: '}</strong>
                                            <label>{values.email}</label>
                                        </div>

                                        <div>
                                            <strong>{icon ? <i className='bi bi-globe' /> : 'Site: '}</strong>
                                            <label>www.distribuidorayork.com.br</label>
                                        </div>

                                        <div>
                                            <strong>{icon ? <i className='bi bi-geo-alt-fill' /> : 'Endereço: '}</strong>
                                            <label>{license.address} - {license.neighborhood}</label>
                                            <div className='mb-1'>
                                                <label style={icon ? { marginLeft: '23px' } : { marginLeft: '80px' }}>
                                                    {license.city}, {license.state}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default Assinatura;